import styled, { css } from 'styled-components';
import { Typography } from '../../../global/theme';
import { mobile_xl } from '../../../global/mediaQueryMixin';
import { AlignCenter, FlexCenter } from '../../../global/commonStyle';
import { Z_INDEX } from '../../../global/constants';

interface Props {
  isActive?: boolean;
  isTrackingActivity?: boolean;
}

const ProjectsName = styled.div<Props>`
  display: flex;
  flex-direction: column;
  gap: var(--space-8);
  ${mobile_xl(css`
    gap: var(--space-4);
  `)}
`;

const ProjectTitle = styled.div`
  padding-inline: var(--space-18);
  width: max-content;
  ${Typography.body_md_medium};
  color: var(--text-secondary);
  ${mobile_xl(css`
    padding-inline: var(--space-8);
    font-weight: 600;
  `)}
`;

const Viewer = styled.div<Props>`
  cursor: pointer;
  ${AlignCenter}
  gap: var(--space-12);
  ${Typography.body_md};
  padding: var(--space-5) var(--space-6);
  color: var(--text-primary);
  &:hover {
    background-color: var(--background-hover-navbar);
    border-radius: var(--border-radius-8);
  }
  ${(props: Props) =>
    props.isActive &&
    css`
      background-color: var(--background-active-navbar);
      border-radius: var(--border-radius-8);
      &:hover {
        background-color: var(--background-active-navbar);
      }
    `}
  ${mobile_xl(css`
    font-weight: 500;
    gap: var(--space-8);
    padding: var(--space-11) var(--space-8);
  `)}
`;

const Icon = styled.div`
  ${FlexCenter}
  ${mobile_xl(css`
    padding-inline: var(--space-2);
    svg {
      width: 20px;
      height: 20px;
    }
  `)}
`;

const ProjectItems = styled.div`
  display: flex;
  flex-direction: column;
  padding-inline: var(--space-12);
  gap: var(--space-2);
  ${mobile_xl(css`
    gap: var(--space-4);
    padding: var(--space-0);
  `)}
`;

const SortableItemWrapper = styled.div<{
  isDragging?: boolean;
  isOverlay?: boolean;
  cssTransform?: string;
  cssTransition?: string;
}>`
  z-index: ${({ isOverlay, isDragging }) => (isOverlay ? Z_INDEX.MODAL : isDragging ? Z_INDEX.BASE : Z_INDEX.ZERO)};
  transform: ${({ cssTransform }) => cssTransform || 'none'};
  transition: ${({ cssTransition }) => cssTransition || 'none'};
  opacity: ${({ isDragging, isOverlay }) => (isDragging && !isOverlay ? 0 : 1)};
  width: 100%;
  pointer-events: ${({ isOverlay }) => (isOverlay ? 'none' : 'auto')};
`;

export { ProjectsName, ProjectTitle, Viewer, Icon, ProjectItems, SortableItemWrapper };
